export default __webpack_public_path__ + "images/MY.22f8788.png";